import router from '@/router'
/**
 * 路由跳转
 * @param {String} str 
 */
function routerTo(str){
  if(str){
    router.push(str)
  }
}

export {
  routerTo
}